import { useMemo } from "react";
import { TipTapEditor } from "@/react/components/shared/BuilderUI/Editor/fields/RichTextField/TipTapEditor";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import {
  convertTipTapToHTML,
  createTipTapFromText,
  isRichTextContent,
} from "../../utils/richTextHelpers";
import type { TextRendererProps } from "./TextRenderer.types";
import { useTextBlockInteraction } from "./useTextBlockInteraction";

export const BuilderTextRenderer = ({
  blockPath,
  text = "",
  className,
  placeholder,
}: TextRendererProps) => {
  const isInlineEditing = useBuilderStore(state => state.isInlineEditing);
  const isCurrentlyInlineEditing = isInlineEditing(blockPath);
  const { handleDoubleClick, handleBlur } = useTextBlockInteraction({
    blockPath,
    text,
  });

  const htmlContent = useMemo(() => {
    if (isRichTextContent(text)) {
      return convertTipTapToHTML(text);
    }
    return null;
  }, [text]);

  if (isCurrentlyInlineEditing) {
    const editorValue = isRichTextContent(text)
      ? text
      : createTipTapFromText(text);
    return (
      <TipTapEditor
        value={editorValue}
        onBlur={handleBlur}
        placeholder={placeholder}
        shouldFocusWhenReady
      />
    );
  }

  if (htmlContent) {
    return (
      <div
        className={className}
        onDoubleClick={handleDoubleClick}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  }

  if (!isRichTextContent(text)) {
    return (
      <span className={className} onDoubleClick={handleDoubleClick}>
        {text || placeholder}
      </span>
    );
  }

  return null;
};
